module.exports = __webpack_public_path__ + "static/media/1POLICY6.003ef5a9.jpg";